export enum DanceManagerSubscriptionStatusEnum {
  INITIALIZED = 'INITIALIZED',
  ACTIVE = 'ACTIVE',
  TERMINATED_PERIOD_END = 'TERMINATED_PERIOD_END',
  TERMINATED = 'TERMINATED',
}
